import { render, staticRenderFns } from "./AttachmentsUploader.vue?vue&type=template&id=93842fea&scoped=true&"
import script from "./AttachmentsUploader.vue?vue&type=script&lang=js&"
export * from "./AttachmentsUploader.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsUploader.vue?vue&type=style&index=0&id=93842fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93842fea",
  null
  
)

export default component.exports